import { baseVariables } from '@marriott/mi-ui-library';

import { getColorByCode } from '../../../modules/utils/helper';
import { MEMBERSHIP_CODES } from '../../../modules';

/**
 * Resolves the tier icon color as a clean CSS color value
 * safe for inline style use (no `!important`).
 *
 * Member-tier codes (R, MB) and falsy values resolve to the brand member color
 * (memberSolid → accent10 → base10 fallback chain).
 * All other tier codes resolve through getColorByCode.
 *
 * Returns undefined when the resolved value is empty.
 */
export const resolveTierIconColor = (tierCode: string | undefined): string | undefined => {
  const raw =
    !tierCode || MEMBERSHIP_CODES.MEMBER_CODES.includes(tierCode)
      ? baseVariables.color.memberSolid || baseVariables.color.accent10 || baseVariables.color.base10
      : getColorByCode(tierCode, false);

  const clean = raw?.replace(/\s*!important$/i, '').trim();
  return clean || undefined;
};
